import React, { createContext, useContext, useEffect, useState } from "react";
import { getPack } from "@/data/packs";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const STORAGE_KEY = "ozentya_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);
  const [promo, setPromo] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ozentya_promo")) || null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    localStorage.setItem("ozentya_promo", JSON.stringify(promo));
  }, [promo]);

  const applyPromo = (code, percent) => setPromo({ code, percent });
  const clearPromo = () => setPromo(null);

  const addItem = (packId, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.id === packId);
      if (found) {
        return prev.map((i) =>
          i.id === packId ? { ...i, qty: Math.min(i.qty + qty, 20) } : i
        );
      }
      return [...prev, { id: packId, qty }];
    });
    setOpen(true);
  };

  const setQty = (packId, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => i.id !== packId)
        : prev.map((i) => (i.id === packId ? { ...i, qty } : i))
    );

  const removeItem = (packId) =>
    setItems((prev) => prev.filter((i) => i.id !== packId));

  const clear = () => setItems([]);

  const detailed = items
    .map((i) => ({ ...i, pack: getPack(i.id) }))
    .filter((i) => i.pack);
  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = detailed.reduce((s, i) => s + i.pack.price * i.qty, 0);
  const discount = promo ? Math.round(total * (promo.percent / 100) * 100) / 100 : 0;
  const totalAfter = Math.round((total - discount) * 100) / 100;

  const clearAll = () => {
    clear();
    clearPromo();
  };

  return (
    <CartContext.Provider
      value={{ items, detailed, count, total, discount, totalAfter, promo, applyPromo, clearPromo,
               addItem, setQty, removeItem, clear, clearAll, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};
